module.exports = __webpack_public_path__ + "assets/img/btn_chip_5.85f4d96f.png";